import type { SRT_SortingState } from '@/shared/components/master-table'
import type { PromoCampaignModel } from '@/shared/generated'

import React, { useEffect, useState } from 'react'
import { prop } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import {
	MasterTable,
	useMasterReactTable,
} from '@/shared/components/master-table'
import { getMasterTableLocale } from '@/shared/i18n'
import { ampli } from '@/shared/lib/ampli'

import getColumn from '../lib/getColumn'

export default function PromoCampaignsTable({
	data,
}: {
	data: PromoCampaignModel[]
}) {
	const { t } = useTranslation()

	const [sorting, setSorting] = useState<SRT_SortingState>([
		{
			id: 'created_on',
			desc: true,
		},
	])
	useEffect(() => {
		ampli.settingsPromoCampaignsTableSortBy({
			value: sorting.map(prop('id')).join(','),
		})
	}, [sorting])
	const columns = getColumn(t)
	const table = useMasterReactTable<PromoCampaignModel>({
		localization: getMasterTableLocale(),
		data,
		columns,
		state: {
			sorting,
		},
		defaultColumn: {
			minSize: 55,
			size: Number.MAX_SAFE_INTEGER,
			maxSize: Number.MAX_SAFE_INTEGER,
		},
		layoutMode: 'grid',
		enableColumnActions: false,
		divideX: false,
		getRowClassName: () => 'h-12',
		onSortingChange: setSorting,
	})

	return <MasterTable table={table} />
}
